module.exports = __webpack_public_path__ + "static/img/kj1.2fae8b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/led/kj1.png
// module id = tdPI
// module chunks = 4